import styled from 'styled-components/macro';

export const Section = styled.section`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const Form = styled.form`
  width:100%;
  text-align: center;
`;
